import { useState } from 'react';
import MediaPlaceholder from './MediaPlaceholder';
import Reveal from './Reveal';
import './About.css';

function AboutPhoto({ src, alt, label, color, className, corner }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <MediaPlaceholder label={label} color={color} className={className} corner={corner} />;
  }

  return (
    <div className={`about-photo ${className}`}>
      <img src={src} alt={alt} onError={() => setFailed(true)} />
      {corner}
    </div>
  );
}

function About() {
  return (
    <section id="about" className="section about">
      <div className="about-grid">
        <Reveal variant="right" className="about-copy">
          <h2 className="about-heading">
            <span className="about-heading-line1">55 Years Of</span>
            <span className="about-heading-line2">Industrial Legacy</span>
          </h2>
          <p className="about-text">
            Founded in 1969 in Sivakasi — India's match and fireworks capital — Sundaravel
            Group began as a single match box manufacturing unit. Through vision, discipline,
            and relentless commitment to quality, we grew into one of the region's most
            trusted industrial conglomerates.
          </p>
          <p className="about-text">
            Today we operate 12 match units, a fireworks factory, Hariram Chemicals, a
            printing division, a college, and a school — with 500+ dedicated employees
            carrying the founding spirit forward every single day.
          </p>
        </Reveal>

        <Reveal variant="left" className="about-media">
          <AboutPhoto
            src="/images/divisions/safety-matches-art.jpg"
            alt="Matches arranged in a heart shape"
            label="Matches close-up"
            color="var(--orange)"
            className="about-media-main"
          />
          <span className="about-founded-badge about-badge-slot">
            <svg className="about-badge-flame" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 2c2.4 3 4 5.6 4 8.2a4 4 0 0 1-8 0C8 7.6 9.6 5 12 2Z" />
            </svg>
            <span className="about-badge-text">
              1969
              <br />
              Founded
            </span>
          </span>
        </Reveal>
      </div>
    </section>
  );
}

export default About;
